export default [{
    title: 'Perfil compartilhado',
    name: 'sharedProfile',
    path: '/revoke/:id',
    component: () => import( /* webpackChunkName: "revoke" */ './Revoke')
}]